import {forwardRef} from 'react'
import {ToastContainer as DsToastContainer} from 'pepsico-ds'
import type {IToastProps, IToastContainerProps} from 'pepsico-ds'

// Wrapper component for the ToastContainer from pepsico-ds
type ToastProps = Omit<IToastContainerProps, 'ref'> & {toasts?: IToastProps[]}

const Toast = forwardRef<any, ToastProps>(({className = '', toasts = [], ...rest}, ref) => {
  return <DsToastContainer ref={ref} className={`select-none ${className}`} data={toasts} {...rest} />
})

Toast.displayName = 'Toast'

export default Toast
